import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      {/* Hero Section */}
      <section className="relative h-screen bg-[#2E492A]">
        <img 
          src="/mamcomviet2.png"
          alt="Featured Vietnamese dishes" 
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="container mx-auto px-4 h-full flex items-center relative z-10">
          <div className="text-white max-w-2xl animate-fadeIn">
            <h1 className="font-['Playfair_Display_SC'] text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
              WELCOME TO
              <br />
              LOTUS STORY RESTAURANT
            </h1>
            <p className="font-['Outfit'] text-base sm:text-lg md:text-xl mb-6 sm:mb-8 leading-relaxed">
              Our menu is thoughtfully curated to showcase the diversity of Vietnamese flavors while 
              incorporating contemporary Australian influences. We offer a variety of tasting menus, each 
              inspired by Vietnam's unique regions, seasonal festivals, and traditional folk tales.
            </p>
            <Link 
              to="/reservation"
              className="inline-block bg-white text-[#2E492A] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-['Outfit'] text-sm sm:text-base font-medium hover:bg-gray-100 transition-colors button-hover"
            >
              Book Now
            </Link>
          </div>
        </div>
      </section>

      {/* Google Reviews */}
      <section className="bg-[#EFEAE7] py-16 sm:py-20">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="mb-4">
              <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">WHAT ADELAIDE </span>
              <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold">IS SAYING</span>
            </h2>
            <div className="flex items-center justify-center gap-4 mb-4">
              <span className="font-['Playfair_Display_SC'] text-[#2E492A] text-5xl md:text-6xl font-bold">5.0</span>
              <div className="text-left">
                <div className="flex gap-1 mb-1">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-[#4F6632] text-lg">★</span>
                  ))}
                </div>
                <p className="font-['Outfit'] text-gray-500 text-sm">Based on Google Reviews</p>
              </div>
            </div>
            <a
              href="https://share.google/fOiLiiFk9pvhGxWF4"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-3 border border-[#4F6632] text-[#4F6632] rounded-full font-['Outfit'] text-sm hover:bg-[#4F6632] hover:text-white transition-colors button-hover"
            >
              Leave a Review ↗
            </a>
          </div>

          {/* Review Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Review 1 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-[#4F6632] text-sm">★</span>
                ))}
              </div>
              <p className="font-['Outfit'] text-gray-700 text-sm leading-relaxed mb-6 italic">
                This is not yet another "Asian" restaurant squeezing in as many customers as possible and with a menu pages long, rather it is spacious, decorative, and comfortable, and while menu is small the options are interesting and the food we had was delicious; furthermore the price was very reasonable - one of us had a main course for $18.50. The staff were attentive, well spoken and informed. I am hard of hearing and usually hate eating out, but on this occasion I had no problem joining in the conversation which suggests there is some insulation. Highly recommended.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#2E492A] flex items-center justify-center text-white font-['Outfit'] text-sm font-medium">J</div>
                <div>
                  <p className="font-['Outfit'] text-black text-sm font-medium">John Aitchison</p>
                  <p className="font-['Outfit'] text-gray-400 text-xs">Google Review</p>
                </div>
              </div>
            </div>

            {/* Review 2 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-[#4F6632] text-sm">★</span>
                ))}
              </div>
              <p className="font-['Outfit'] text-gray-700 text-sm leading-relaxed mb-6 italic">
                My husband and I found this restaurant through top reviews of restaurants in North Adelaide and we were not disappointed. We enjoyed lunch here and the food was both authentic and delicious with wonderful service at reasonable prices. We highly recommend Lotus Story and we will be back.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#4F6632] flex items-center justify-center text-white font-['Outfit'] text-sm font-medium">D</div>
                <div>
                  <p className="font-['Outfit'] text-black text-sm font-medium">Diane D.</p>
                  <p className="font-['Outfit'] text-gray-400 text-xs">Google Review</p>
                </div>
              </div>
            </div>

            {/* Review 3 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-[#4F6632] text-sm">★</span>
                ))}
              </div>
              <p className="font-['Outfit'] text-gray-700 text-sm leading-relaxed mb-6 italic">
                Lovely infusion of flavours. A cut above other Vietnamese restaurants. Wonderful service. Highly recommend.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#2E492A] flex items-center justify-center text-white font-['Outfit'] text-sm font-medium">B</div>
                <div>
                  <p className="font-['Outfit'] text-black text-sm font-medium">Bill Lochting</p>
                  <p className="font-['Outfit'] text-gray-400 text-xs">Google Review</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-[#2E492A] text-white">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl text-center">
          <h2 className="font-['Playfair_Display_SC'] text-3xl md:text-4xl font-bold mb-6">
            Experience the Flavors of Vietnam
          </h2>
          <p className="font-['Outfit'] mb-8 max-w-2xl mx-auto">
            Join us for lunch or dinner and discover why Lotus Story is Adelaide's premier 
            destination for authentic Vietnamese cuisine.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/menu"
              className="inline-block bg-white text-[#2E492A] px-8 py-3 rounded-full hover:bg-gray-100 transition-colors button-hover"
            >
              View Menu
            </Link>
            <Link 
              to="/reservation"
              className="inline-block bg-transparent border-2 border-white text-white px-8 py-3 rounded-full hover:bg-white hover:text-[#2E492A] transition-colors button-hover"
            >
              Make a Reservation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 